/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for anypurpose without the express written permission of Honeywell. */
import { createTheme, CssBaseline, Theme, ThemeProvider } from "@mui/material";
import { NavigateBar } from "./components/NavigateBar/NavigateBar";
import { BrowserRouter } from "react-router-dom";
import { OidcProvider, OidcSecure } from "@axa-fr/react-oidc";
import { ConfigurationVariables } from "./config";
import React from "react";

const darkTheme: Theme = createTheme({
  palette: {
    background: {
      default: "#202020",
    },
    text: {
      primary: "#FFFFFF",
      secondary: "#FFFFFF",
    },
  },
  components: {
    MuiFormLabel: {
      styleOverrides: {
        asterisk: { color: "red" },
      },
    },
    MuiCircularProgress: {
      styleOverrides: {
        root: {
          color: "#fff",
        },
      },
    },
    MuiDataGrid: {
      styleOverrides: {
        root: {
          "& .MuiDataGrid-iconButtonContainer": {
            visibility: "visible",
          },
          "& .MuiDataGrid-sortIcon": {
            color: "white",
            opacity: "inherit !important",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "1px solid black ",
          },
          "& .MuiDataGrid-withBorderColor": {
            borderColor: "black ",
          },
        },
        footerContainer: {
          "&.MuiDataGrid-footerContainer": {
            minHeight: "5vh",
            height: "5vh",
            justifyContent: "center",
          },
        },
      },
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          fontSize: "1.2rem",
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          fontSize: "0.6rem",
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiInputBase-input": {
            fontSize: "0.75rem",
            fontWeight: 500,
            fontFamily: "Honeywell Sans Web",
            fontStyle: "normal",
          },
          "& .MuiFormLabel-root": {
            fontSize: "13px",
            fontWeight: 500,
          },
          height: "auto",
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          height: "3.5vh",
        },
        input: {
          padding: 0,
          padidingLeft: "5px !important",
          marginTop: 0,
          marginLeft: 0,
          marginBottom: 0,
          height: "3.5vh",
        },
      },
    },
    // MuiOutlinedInput: {
    //   styleOverrides: {
    //     input: {
    //       padding: 0,
    //       marginTop: 0,
    //       marginLeft: 0,
    //       marginBottom: 0,
    //     },
    //   },
    // },
    MuiList: {
      styleOverrides: {
        root: {
          paddingTop: 0,
          paddingBottom: 0,
          backgroundColor: "#272727",
          "& .MuiPaginationDropdown": {
            fontSize: "13px",
            fontWeight: 500,
          },
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: { padding: "4px" },
      },
    },

    MuiToolbar: {
      styleOverrides: {
        root: {
          "@media (min-width: 600px)": {
            minHeight: "6vh",
            paddingLeft: "1.55vh",
          },
        },
      },
    },
    MuiPaginationItem: {
      styleOverrides: {
        root: {
          fontSize: "12px",
          height: 20,
          width: 10,
          "&.Mui-selected": { backgroundColor: "#272727", color: "#64C3FF" },
        },
      },
    },
    MuiTablePagination: {
      styleOverrides: {
        displayedRows: {
          fontSize: 10,
          fontFamily: "Honeywell Sans Web",
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        listbox: {
          paddingTop: "0px",
          paddingBottom: "0px",
          backgroundColor: "#272727",
        },
        root: {
          "& .MuiOutlinedInput-root": {
            padding: "0px",
            paddingRight: "5px",
          },
          "& ..MuiAutocomplete-tag": {
            margin: "0px",
          },
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: "white",
          color: "black",
          borderRadius: "0px",
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: "#272727",
        },
      },
    },
  },
} as any);

export const configuration = {
  // IAM configuration
  client_id: ConfigurationVariables.FORGE_IAM_CLIENT_ID,
  redirect_uri: ConfigurationVariables.KONG_URL + "callback",
  scope: ConfigurationVariables.FORGE_IAM_SCOPE,
  authority: ConfigurationVariables.FORGE_IAM_AUTHORITY,
};
function App() {
  return (
    <OidcProvider configuration={configuration}>
      <BrowserRouter>
        <ThemeProvider theme={darkTheme}>
          <CssBaseline />
          <OidcSecure>
            <NavigateBar />
          </OidcSecure>
        </ThemeProvider>
      </BrowserRouter>
    </OidcProvider>
  );
}

export default App;
